import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["modifier"];
import React from 'react';
import PropTypes from 'prop-types';
import { getModifiers } from '../../../../helpers';
import TextSummaryContent from './TextSummaryContent';
const TextSummary = _ref => {
  let {
      modifier
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: getModifiers('stats', modifier)
  }, /*#__PURE__*/React.createElement(TextSummaryContent, otherProps));
};
TextSummary.propTypes = {
  modifier: PropTypes.string
};
TextSummary.defaultProps = {
  modifier: ''
};
export default TextSummary;
//# sourceMappingURL=TextSummary.js.map